import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from "@angular/core";
import { AssigneeService, TaxReturnService, Population, Client, NoteService } from "../../../../../swaggerServices";
import { TaxReturnAction, TaxReturnStatus } from "../../../../app/tax-returns/tax-return/model/status";
import { makeName } from "../../../util/makeName";
import { ITaxReturn } from "../../../../app/tax-returns/tax-return/model/i-tax-return";
import { UserInfoService } from "../../../../app/user-info.service";
import { ConfigStateService } from "../../../../app/config/config-state.service";
import { IAssignee } from "../../../types/assignee";
import { getQuestionnaireType } from "../../../util/questionnaire-type.util";
import { Tenant } from "../../../types/tenant.enum";
import { ActivatedRoute } from "@angular/router";
import { LocalStorageTimerService } from "../../../services/local-storage-timer.service";
import { TenantConfigService } from "../../../services/tenant-config.service";
import { Subscription } from "rxjs";
import { setStatus } from "../../../../app/tax-returns/get-full-tax-return";
import { DropdownListOption } from "../../../../shared/components/search-dropdown/search-dropdown.component";
declare var $: any;

@Component({
    selector: "app-tax-return-list-item",
    templateUrl: "./tax-return-list-item.component.html",
    styleUrls: ["./tax-return-list-item.component.scss"],
    standalone: false
})
export class TaxReturnListItemComponent implements OnInit, OnDestroy {
  @Input() assignee: IAssignee;
  @Input() taxReturn: ITaxReturn;
  @Input() isPopulationPage: boolean;
  @Input() isClientTaxreturnsPage?: boolean;
  @Input() showBulkProcess: boolean;
  @Input() showQnrType: boolean;
  @Input() selected: boolean;
  @Input() showTaxReturnType: boolean;
  @Input() disableStartProcess: boolean;
  @Input() disableBulkStartProcess: boolean;
  @Input() taxReturnAlias: string;
  @Input() taxpayerAlias: string;

  @Output() actionRequested: EventEmitter<{ taxReturn: ITaxReturn, action: TaxReturnAction }> = new EventEmitter<{ taxReturn: ITaxReturn, action: TaxReturnAction }>();
  @Output() activeToggled: EventEmitter<{ assignee: IAssignee, taxReturn: ITaxReturn }> = new EventEmitter<{ assignee: IAssignee, taxReturn: ITaxReturn }>();
  @Output() deleteDataEmit: EventEmitter<{ taxReturnOrTaxpayer: ITaxReturn | IAssignee }> = new EventEmitter<{ taxReturnOrTaxpayer: ITaxReturn | IAssignee }>();
  @Output() addSpouseEmit: EventEmitter<void> = new EventEmitter<void>();
  @Output() moveTaxpayerEmit: EventEmitter<void> = new EventEmitter<void>();
  @Output() viewInfoEmit: EventEmitter<ITaxReturn> = new EventEmitter<ITaxReturn>();
  @Output() viewNotesEmit: EventEmitter<void> = new EventEmitter<void>();
  @Output() selectChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('menuTarget') menuTarget: ElementRef;
  @ViewChild('confirmCloseTaxReturn') confirmCloseTaxReturn: ElementRef;
  @ViewChild('confirmOpenTaxReturn') confirmOpenTaxReturn: ElementRef;
  @ViewChild('confirmDeleteTaxReturn') confirmDeleteTaxReturn: ElementRef;
  @ViewChild('confirmDeleteTaxpayer') confirmDeleteTaxpayer: ElementRef;
  @ViewChild('confirmDeleteAllAnswers') confirmDeleteAllAnswers: ElementRef;
  @ViewChild('preparerType') preparerType: ElementRef;
  hover: boolean;
  @Input() showHeader: boolean;
  showBulkAction: boolean = false;
  showBulkStatusUpdate: boolean = false;
  isEss: boolean = false;
  bulkProcessing = false;
  questionnaireTypeName: string;
  showResubmitOrChangeBtn: boolean;
  canMovePopulation: boolean;
  canDeleteData: boolean;
  currentPopulation: Population;
  uiConfig: TenantConfigService;
  gtsIdVariable: string | null;
  subscriptions: Subscription[] = [];
  closedReason: string = "";
  deleteTaxReturnPromptOpen: boolean = false;
  oneTeamIntegrationEnabled: boolean;
  disableActionButton = false;
  snoozeWarning = false;
  preparerTypeOptions: DropdownListOption[] = [];
  amendedTypeOptions: DropdownListOption[] = [];
  showProjectStatusOptions = false;
  isAmended = false;
  enableLodgeForUser = false;
  enableProjectStatusOptions = [0,50,1,58,2,3,59,4,5,61,62];
  /**list of project form statuses
   *  Not Started -0
      Waiting for Prep- 50
      Prep -1
      Prep-Package Generated-58
      Waiting for Review1-2
      Review1-3
      Review1-Package Generated-59
      Waiting for Review2 -4
      Review2-5
   */
  enableAmendedProjectStatusOptions = [9,10,11,12,13,14,64,67,68,69];
  /* list of amended equivalent statuses:
    amendmentPrep: 9,
    amendmentWaitingForReviewer1: 10,
    amendmentReviewer1: 11,
    amendmentWaitingForReviewer2: 12,
    amendmentReviewer2: 13,
    amendmentSubmittedToAssignee: 14,
    amendmentPrepGeneratingTaxReturn: 64,
    amendmentPrepGenerationComplete: 67,
    amendmentReviewer1GenerationComplete: 68,
    amendmentReviewer2GenerationComplete: 69
  */
  constructor(private assigneeService: AssigneeService,
    public userInfo: UserInfoService,
    private taxReturnService: TaxReturnService,
    private activatedRoute: ActivatedRoute,
    public config: ConfigStateService,
    private timerService: LocalStorageTimerService,
    private noteService: NoteService) {
  }

  ngOnInit() {
    this.questionnaireTypeName = getQuestionnaireType(this.taxReturn.questionnaireType);
    this.showResubmitOrChangeBtn = this.config.tenant === Tenant.SG;
    this.isEss = this.config.tenant === Tenant.ESS;
    this.oneTeamIntegrationEnabled=this.config.featureFlags.enableOneteamIntegration;
    this.showBulkAction = this.isClientTaxreturnsPage ? this.config.featureFlags.showBulkActionOnClientTaxpayersPage : (!!this.activatedRoute.params['value'].populationId && this.config.featureFlags.showBulkActionOnPopulationPage);
    this.canMovePopulation = this.checkCountryAccess() && (this.config.tenant === Tenant.SG || this.config.tenant === Tenant.ESS || this.userInfo.isAdmin);
    this.currentPopulation = (this.assignee.populations) ? this.assignee.populations.find(p => p.id === this.taxReturn.populationId) : null;
    this.canDeleteData = this.userInfo.isAdmin && this.checkCountryAccess();
    this.subscriptions.push(this.config.loadConfig().subscribe((config) => {
      this.uiConfig = new TenantConfigService(config);
      this.gtsIdVariable = this.uiConfig.config.gtsId;
    }))
    if (this.isTrActive() === false) {
      this.updateClosedReason();
    }
    this.isAmended = this.enableAmendedProjectStatusOptions.includes(this.taxReturn.status);
    this.projectFormStatusDropdown(this.isAmended);
  }

  projectFormStatusDropdown(isAmended){
    this.showProjectStatusOptions =
      this.enableProjectStatusOptions.includes(this.taxReturn.status) ||
      this.enableAmendedProjectStatusOptions.includes(this.taxReturn.status);

    if(this.showProjectStatusOptions){
      const enableLodgeForUser = this.userInfo.isClientAdmin || this.userInfo.isAdmin || this.userInfo.isSuperAdmin;

      this.preparerTypeOptions = [
        { id: 1, name: "Prepare", value: "1", order: 1, selected: this.taxReturn.status === 1 },
        { id: 3, name: "Review1", value: "3", order: 2, selected: this.taxReturn.status === 3 },
        { id: 5, name: "Review2", value: "5", order: 3, selected: this.taxReturn.status === 5 },
        { id: 7, name: "Lodge", value: "7", order: 4, selected: this.taxReturn.status === 5, disabled: !enableLodgeForUser },
      ];

      this.amendedTypeOptions = [
        { id: 9, name: "Amended Prepare", value: "9", order: 1, selected: this.taxReturn.status === 9 },
        { id: 11, name: "Amended Review1", value: "11", order: 2, selected: this.taxReturn.status === 11 },
        { id: 13, name: "Amended Review2", value: "13", order: 3, selected: this.taxReturn.status === 13 },
        { id: 15, name: "Amended Lodge", value: "15", order: 4, selected: this.taxReturn.status === 13, disabled: !enableLodgeForUser },
      ]

      setTimeout(() => {
        $(this.preparerType.nativeElement).dropdown({
          values: isAmended ? this.amendedTypeOptions : this.preparerTypeOptions,
          placeholder: "Select...",
          fullTextSearch: "exact",
          preserveHTML: false,
          onChange: (value: string) => {
            if (value) {
              if(this.taxReturn.status === parseInt(value)){
                return;
              }
              this.taxReturnService.updateTaxReturnStatus(this.taxReturn.id, { status: value })
                .subscribe(() => {
                  this.activeToggled.emit({
                    assignee: this.assignee,
                    taxReturn: this.taxReturn
                  });
                });
            }
          }
        });
      });
    }
  }

  updateClosedReason() {
    this.noteService.getNotesByTaxReturnId(this.taxReturn.id).subscribe(result => {
      for (let i = 0; i < result.notes.length; i++) {
        const note = result.notes[i];
        if (note.title === "Closed Reason" && note.startYear === this.taxReturn.year && note.endYear === this.taxReturn.year) {
          this.closedReason = note.body;
          return;
        }
      }
      this.closedReason = "";
    });
  }

  ngOnDestroy() {
    if (this.canDeleteData && this.deleteTaxReturnPromptOpen && this.confirmDeleteTaxReturn) {
      $(this.confirmDeleteTaxReturn.nativeElement).modal('hide');
    }
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  checkCountryAccess() {
    if (this.userInfo.isSuperAdmin) return true;
    // TODO: taxReturn.countryId isn't in the taxReturn declaration but exists on data object, add it to the "TaxReturnFull" declaration
    if (!this.taxReturn["countryId"]) return true;
    if (this.userInfo.countries.some(c => c.id == this.taxReturn["countryId"])) return true;
    else return false;
  }

  // expose this helper method to the template
  makeName(user: { firstName?: string; lastName?: string }): string {
    return makeName(user);
  }

  doAction(action: TaxReturnAction) {
    if (action.name === 'Start Process' || action.name === 'Check for Prefill') {
      if (this.disableActionButton || this.disableStartProcess) {
        return false;
      } else {
        this.disableActionButton = true;
      }
    }
    this.actionRequested.emit({ taxReturn: this.taxReturn, action });
  }

  bulkProcessNoQnr() {
    if (this.disableActionButton || this.disableStartProcess || this.disableBulkStartProcess) {
      return false;
    }
    this.bulkProcessing = true;
    this.doAction(TaxReturnAction.BULK_PROCESS_NO_QNR);
  }

  // determine if taxpayer is active or not
  isActive() {
    return this.assignee.status !== 99;
  }

  // toggle active/inactive assignee status
  toggleStatus() {

    if (this.isActive()) {
      this.assigneeService.deleteAssigneeById(this.assignee.id).subscribe(
        () => this.activeToggled.emit({ assignee: this.assignee, taxReturn: this.taxReturn }))
    } else {
      this.assigneeService.updateAssignee({
        id: this.assignee.id,
        firstName: this.assignee.firstName,
        lastName: this.assignee.lastName,
        atlasId: this.assignee.atlasId,
        gtsId: this.gtsIdVariable ? this.assignee.gtsId : this.assignee.atlasId,
        status: 0,
      }).subscribe(
        () => this.activeToggled.emit({ assignee: this.assignee, taxReturn: this.taxReturn })
      )
    }
  }

  // determine if taxpayer is active or not
  isTrActive() {
    return this.taxReturn.status !== 99;
  }

  // toggle open/closed taxReturn status
  toggleTrStatus(reason?: string) {
    if (this.isTrActive()) { // Close Tax Return
      if (!reason) {
        this.getCloseTrReason();
        return;
      }
      this.taxReturnService.closeTaxReturn(this.taxReturn.id, {
        closedReason: this.closedReason,
      }).subscribe((response) => {
        this.taxReturn.status = response.status;
        this.closedReason = response.closedReason;
        setStatus(this.taxReturn)
        this.updateClosedReason();
      })
    } else { // Open Tax Return
      $(this.confirmOpenTaxReturn.nativeElement).modal({
        onApprove: () => {
          this.taxReturnService.openTaxReturn(this.taxReturn.id).subscribe((response) => {
            this.taxReturn.status = response.status;
            setStatus(this.taxReturn)
            this.updateClosedReason();
          })
        }
      }).modal('show');
    }
  }

  getCloseTrReason() {
    $(this.confirmCloseTaxReturn.nativeElement).modal({
      onApprove: () => {
        this.toggleTrStatus(this.closedReason)
      }
    }).modal('show');
  }

  confirmOpenTR() {

  }

  confirmDelete(type) {
    if (type === 'TP') {
      // check if the token is still within 10 minutes
      if (this.timerService.hasTokenExpired("snoozeWarningDeleteData", (10 * 60))) {
        $(this.confirmDeleteTaxpayer.nativeElement).modal({
          onApprove: () => {
            if (this.snoozeWarning) {
              this.timerService.storeToken("snoozeWarningDeleteData");
            }
            this.assigneeService.deleteDataForAssignee(this.assignee.id).subscribe(
              () => this.deleteDataEmit.emit({ taxReturnOrTaxpayer: this.assignee }))
          }
        }).modal('show');
      } else {
        this.assigneeService.deleteDataForAssignee(this.assignee.id).subscribe(
          () => this.deleteDataEmit.emit({ taxReturnOrTaxpayer: this.assignee }));
      }
    }
    if (type === 'TR') {
      // check if the token is still within 10 minutes
      if (this.timerService.hasTokenExpired("snoozeWarningDeleteData", (10 * 60))) {
        this.deleteTaxReturnPromptOpen = true;
        $(this.confirmDeleteTaxReturn.nativeElement).modal({
          onApprove: () => {
            if (this.snoozeWarning) {
              this.timerService.storeToken("snoozeWarningDeleteData");
            }
            this.taxReturnService.deleteDataForTaxReturn(this.taxReturn.id).subscribe(
              () => this.deleteDataEmit.emit({ taxReturnOrTaxpayer: this.taxReturn }))
          }
        }).modal('show');
      } else {
        this.taxReturnService.deleteDataForTaxReturn(this.taxReturn.id).subscribe(
          () => this.deleteDataEmit.emit({ taxReturnOrTaxpayer: this.taxReturn }));
      }
    }
    if (type === 'TRA') {
      // check if the token is still within 10 minutes
      if (this.timerService.hasTokenExpired("snoozeWarningDeleteData", (10 * 60))) {
        $(this.confirmDeleteAllAnswers.nativeElement).modal({
          onApprove: () => {
            if(this.snoozeWarning) {
              this.timerService.storeToken("snoozeWarningDeleteData");
            }
            this.taxReturnService.deleteAnswersForTaxReturn(this.taxReturn.id)
            .subscribe()
          }
        }).modal('show');
      } else {
        this.taxReturnService.deleteAnswersForTaxReturn(this.taxReturn.id).subscribe();
      }
    }
  }

  addSpouse() {
    this.addSpouseEmit.emit();
  }

  canAddSpouse(assignee: IAssignee) {
    return !this.taxReturn || !this.taxReturn.spouse && this.assignee.status !== 99;
  }

  moveTaxpayer() {
    this.moveTaxpayerEmit.emit();
  }

  viewInfo() {
    this.viewInfoEmit.emit(this.taxReturn);
  }

  viewNotes() {
    this.viewNotesEmit.emit();
  }

  isTaxReturnLodged() {
    return (this.taxReturn && (
      this.taxReturn.status === TaxReturnStatus.LODGED.id ||
      this.taxReturn.status === TaxReturnStatus.AMENDMENT_LODGED.id ||
      this.taxReturn.status === TaxReturnStatus.REVISION_LODGED.id
    ));
  }

  backToResubmit() {
    this.taxReturnService.backToResubmit(this.taxReturn.id)
      .subscribe((tr: ITaxReturn) => {
        this.activeToggled.emit({ assignee: this.assignee, taxReturn: tr });
      });
  }

  backForChanges() {
    this.taxReturnService.backForChanges(this.taxReturn.id)
      .subscribe((tr: ITaxReturn) => {
        this.activeToggled.emit({ assignee: this.assignee, taxReturn: tr });
      });
  }
}
